var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Multiselect } from '../Multiselect/index.js';
import { FormControlMeta } from './FormControlMeta.js';
import { Label } from './Label.js';
export const FormControlMultiselect = props => {
    const { name, label, helperText, error, invalid, onChange, placeholder, value = [], options } = props, rest = __rest(props, ["name", "label", "helperText", "error", "invalid", "onChange", "placeholder", "value", "options"]);
    return (React.createElement("div", null,
        label ? React.createElement(Label, { htmlFor: name }, label) : null,
        React.createElement("div", { className: "mt-1" },
            React.createElement(Multiselect, Object.assign({}, rest, { onChange: onChange, name: name, invalid: invalid, value: value || [], options: options }),
                React.createElement(Multiselect.Button, { placeholder: placeholder }, value === null || value === void 0 ? void 0 : value.map((item, index) => (React.createElement(Multiselect.SelectedItem, { key: index, value: item, index: index }, item)))),
                React.createElement(Multiselect.Items, null, options.map((item, index) => (React.createElement(Multiselect.Item, { key: index, value: item, index: index }, item))))),
            React.createElement(FormControlMeta, Object.assign({}, { helperText, error, invalid })))));
};
//# sourceMappingURL=FormControlMultiselect.js.map